module.exports = __webpack_public_path__ + "img/66_1.d3bc1cc3.png";